// extracted by mini-css-extract-plugin
module.exports = {"Back":"Back_Back__2ZF3R","BackSvg":"Back_BackSvg__3SzAR"};